module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "task-info-wrap"
  }, [_c('div', {
    staticClass: "mod-title border"
  }, [_vm._v("任务详情")]), _vm._v(" "), _c('detail-form', {
    attrs: {
      "name": false,
      "read": true,
      "sub": {},
      "detailData": _vm.detail_data,
      "taskId": _vm.task_id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mod-title border"
  }), _vm._v(" "), _c('div', {
    staticClass: "alone-func"
  }, [_c('transition', {
    attrs: {
      "name": "up"
    }
  }, [_c('div', {
    staticClass: "relation"
  }, [_c('div', {
    staticClass: "mod-title"
  }, [_vm._v("关联任务：")]), _vm._v(" "), _c('relation', {
    attrs: {
      "detailData": _vm.detail_data
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "up"
    }
  }, [_c('div', {
    staticClass: "remark"
  }, [_c('div', {
    staticClass: "mod-title"
  }, [_vm._v("任务备注：")]), _vm._v(" "), _c('remarks', {
    attrs: {
      "read": true,
      "detailData": _vm.detail_data,
      "taskId": _vm.task_id
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-17b52818!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/read-taskDetail.vue
// module id = 700
// module chunks = 1